import { endOfDay, startOfYear } from 'date-fns';
import { Box, Grid } from '@mui/material';

import DashboardCard from '../components/DashboardCard';
import MexicoSalesMap from './MexicoSalesMap';
import StateSalesTable from './StateSalesTable';
import DashboardOrdersExportButton from '../components/DashboardOrdersExportButton';

const StateSalesSection = ({ year, today, countrySalesData, topStatesData }) => (
    <Box sx={{ mt: 6 }}>
        <DashboardCard
            title={`Top 10 estados en ventas (${year})`}
            action={
                <DashboardOrdersExportButton
                    reportType="top_states"
                    range={{
                        startDate: startOfYear(today),
                        endDate: endOfDay(today)
                    }}
                    filename={`pedidos_top-estados_${year}.csv`}
                />
            }
        >
            <Grid container spacing={3}>
                <Grid item xl={7} lg={7} md={12} sm={12} xs={12}>
                    <MexicoSalesMap countrySalesData={countrySalesData} />
                </Grid>
                <Grid item xl={5} lg={5} md={12} sm={12} xs={12}>
                    <StateSalesTable rows={topStatesData} />
                </Grid>
            </Grid>
        </DashboardCard>
    </Box>
);

export default StateSalesSection;
